/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { selectUserData, selectUserStatus } from './userAccounts.slice';
import { getUserThunk, postSwitchOrganizationThunk } from './userAccounts.thunk';
import { selectAuthUserData } from '../../auth/auth.slice';

export function useUserAccounts() {
  const dispatch = useDispatch();

  const status = useSelector(selectUserStatus);
  const user = useSelector(selectUserData);

  /*
  Get the current organization Id and compare it with the account ids
  inside groups array and extract it in order to use it in the dropdown menu
  */
  const currentOrgId = user?.currentOrganizationId;

  const isCurrentOrg = (currentOrg) => {
    return currentOrg.id === currentOrgId;
  };
  const currentOrganization = user?.groups.find(isCurrentOrg);

  const { sub: userId } = useSelector(selectAuthUserData);

  const handleChangeOrganizationId = async (organizationId) => {
    return dispatch(postSwitchOrganizationThunk(organizationId));
  };

  useEffect(() => {
    if (status === ThunkStatus.IDLE) {
      dispatch(getUserThunk(userId));
    }
  }, [userId]);

  return {
    user,
    handleChangeOrganizationId,
    currentOrganization,
  };
}
